export const formatDate = timestamp => {
  const d = new Date(timestamp)
  const day = d.getDate().toString().padStart(2, '0')
  const month = d.toLocaleString('en-GB', { month: 'short' })
  const year = d.getFullYear()
  const hours = d.getHours()
  const mins = d.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  const h = (hours % 12 || 12).toString().padStart(2, '0')
  return `${day} ${month} ${year}, ${h}:${mins} ${ampm}`
}
